var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFunctionWithBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#D8E6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 7C20.25 6.58579 20.5858 6.25 21 6.25H25C25.4142 6.25 25.75 6.58579 25.75 7V11C25.75 11.4142 25.4142 11.75 25 11.75C24.5858 11.75 24.25 11.4142 24.25 11V7.75H21C20.5858 7.75 20.25 7.41421 20.25 7Z",
    fill: "#1570EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5303 6.46967C25.8232 6.76256 25.8232 7.23744 25.5303 7.53033L19.5303 13.5303C19.2374 13.8232 18.7626 13.8232 18.4697 13.5303C18.1768 13.2374 18.1768 12.7626 18.4697 12.4697L24.4697 6.46967C24.7626 6.17678 25.2374 6.17678 25.5303 6.46967Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 20.25C7.41421 20.25 7.75 20.5858 7.75 21V24.25H11C11.4142 24.25 11.75 24.5858 11.75 25C11.75 25.4142 11.4142 25.75 11 25.75H7C6.58579 25.75 6.25 25.4142 6.25 25V21C6.25 20.5858 6.58579 20.25 7 20.25Z",
    fill: "#1570EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5303 18.4697C13.8232 18.7626 13.8232 19.2374 13.5303 19.5303L7.53033 25.5303C7.23744 25.8232 6.76256 25.8232 6.46967 25.5303C6.17678 25.2374 6.17678 24.7626 6.46967 24.4697L12.4697 18.4697C12.7626 18.1768 13.2374 18.1768 13.5303 18.4697Z",
    fill: "#1570EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 16C5.25 10.0658 10.0658 5.25 16 5.25C16.7404 5.25 17.4696 5.32508 18.1671 5.46458C18.5733 5.54581 18.8367 5.94093 18.7555 6.3471C18.6742 6.75327 18.2791 7.01668 17.8729 6.93545C17.2704 6.81494 16.6396 6.75 16 6.75C10.8942 6.75 6.75 10.8942 6.75 16C6.75 16.6393 6.81487 17.2593 6.935 17.8507C7.01746 18.2566 6.75523 18.6525 6.34931 18.735C5.94338 18.8174 5.54748 18.5552 5.46502 18.1493C5.32516 17.4607 5.25 16.7407 5.25 16Z",
    fill: "#1570EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6529 13.2645C26.0591 13.1832 26.4542 13.4466 26.5354 13.8528C26.6747 14.5492 26.75 15.2684 26.75 15.9999C26.75 21.9341 21.9342 26.7499 16 26.7499C15.2597 26.7499 14.5304 26.6748 13.8329 26.5353C13.4267 26.4541 13.1633 26.059 13.2446 25.6528C13.3258 25.2466 13.7209 24.9832 14.1271 25.0645C14.7296 25.185 15.3604 25.2499 16 25.2499C21.1058 25.2499 25.25 21.1057 25.25 15.9999C25.25 15.3714 25.1853 14.7506 25.0646 14.147C24.9833 13.7408 25.2468 13.3457 25.6529 13.2645Z",
    fill: "#1570EF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionWithBg);
export default __webpack_public_path__ + "static/media/function-with-bg.96b02b9f114d8b24faa0f9fff5c79a0b.svg";
export { ForwardRef as ReactComponent };